<template>
  <div class="form container-socio-form" :class="{'is-preview': preview}">
    <p><strong>Quais os dados do sócio?</strong></p>
    <br/>
    <div class="columns is-multiline">
      <div class="column is-12">
        <TrfInput
          label="Nome"
          placeholder="Nome"
          margin="0"
          id="processo-form-socio-nome"
          v-model="formData.nome"
          maxLength="50"
          ref="campoSocioNome"
          v-e2e="'nome-socio-processo'"
          :required="false"
        ></TrfInput>
      </div>
      <div class="column is-6">
        <TrfDocumentoInput
          label="CPF"
          :aceitaCPF="true"
          :aceitaCNPJ="false"
          placeholder="Número do CPF"
          margin="0"
          id="processo-form-socio-cpf"
          v-model="formData.cpf"
          ref="campoSocioCPF"
          v-e2e="'cpf-socio-processo'"
          :required="false"
        ></TrfDocumentoInput>
      </div>
      <div class="column is-6">
        <TrfDateInput
          :isDiaMesEAno="true"
          label="Data de nascimento"
          placeholder="DD/MM/AAAA"
          id="processo-form-socio-data-nascimento"
          maxlength="10"
          v-model="formData.nascimento"
          ref="campoSocioDataNascimento"
          v-e2e="'dataNascimento-socio-processo'"
          :required="false"
        ></TrfDateInput>
      </div>
      <div class="column is-4">
        <TrfInput
          label="Identidade"
          placeholder="Número do RG"
          margin="0"
          id="processo-form-socio-rg"
          v-model="formData.identidade"
          maxLength="15"
          ref="campoSocioRg"
          v-e2e="'rg-socio-processo'"
          :required="false"
        ></TrfInput>
      </div>
      <div class="column is-4">
        <TrfInput
          label="Órgão expedidor"
          placeholder="Órgão expedidor (ex: SSPRS)"
          margin="0"
          id="processo-form-socio-orgao-emissor"
          v-model="formData.orgaoEmissorIdentidade"
          maxLength="10"
          ref="campoSocioOrgaoEmissor"
          v-e2e="'orgaoEmissorRg-socio-processo'"
          :required="false"
        ></TrfInput>
      </div>
      <div class="column is-4">
        <TrfDateInput
          :isDiaMesEAno="true"
          label="Data de emissão"
          placeholder="DD/MM/AAAA"
          id="processo-form-socio-emissao-identidade"
          maxlength="10"
          v-model="formData.emissaoIdentidade"
          ref="campoSocioEmissaoIdentidade"
          v-e2e="'dataEmissaoRg-socio-processo'"
          :required="false"
        ></TrfDateInput>
      </div>
    </div>
    <br/>
    <p><strong>Quais os dados complementares do sócio?</strong></p>
    <br/>
    <div class="columns is-multiline">
      <div class="column is-4">
        <TrfSelect
          :options="listagemSexo"
          :noOptionsText="'Sexos não encontrados'"
          label="Sexo"
          idSelect="processo-form-socio-sexo"
          @valueSelect="$event => setSexo($event)"
          placeholder="Selecione"
          :required="false"
          ref="campoSocioSexo"
          :loading-data="loadingSelects"
          v-e2e="'sexo-socio-processo'"
        ></TrfSelect>
      </div>
      <div class="column is-4">
        <TrfSelect
          :options="listagemCor"
          :noOptionsText="'Cores não encontradas'"
          label="Cor"
          idSelect="processo-form-socio-cor"
          @valueSelect="$event => setCor($event)"
          placeholder="Selecione"
          :required="false"
          ref="campoSocioCor"
          :loading-data="loadingSelects"
          v-e2e="'cor-socio-processo'"
        ></TrfSelect>
      </div>
      <div class="column is-4">
        <TrfSelect
          :options="listagemEscolaridade"
          :noOptionsText="'Escolaridades não encontradas'"
          label="Escolaridade"
          idSelect="processo-form-socio-escolaridade"
          @valueSelect="$event => setEscolaridade($event)"
          placeholder="Selecione"
          :required="false"
          ref="campoSocioEscolaridade"
          :loading-data="loadingSelects"
          v-e2e="'escolaridade-socio-processo'"
        ></TrfSelect>
      </div>
      <div class="column is-6">
        <TrfSelect
          :options="listagemPaises"
          :noOptionsText="'Países não encontrados'"
          label="País de nascimento"
          idSelect="processo-form-socio-pais-de-nascimento"
          @valueSelect="$event => setPaisDeNasciomento($event)"
          placeholder="Selecione"
          :required="false"
          ref="campoSocioPaisDeNascimento"
          :loading-data="loadingSelects"
          v-e2e="'paisNascimento-socio-processo'"
        ></TrfSelect>
      </div>
      <div class="column is-6">
        <TrfSelect
          :options="listagemPaises"
          :noOptionsText="'Países não encontrados'"
          label="Nacionalidade"
          idSelect="processo-form-socio-nacionalidade"
          @valueSelect="$event => setNacionalidade($event)"
          placeholder="Selecione"
          :required="false"
          ref="campoSocioNacionalidade"
          :loading-data="loadingSelects"
          v-e2e="'nacionalidade-socio-processo'"
        ></TrfSelect>
      </div>
      <div v-if="formData.nacionalidade == 105" class="column is-6">
        <TrfSelect
          :options="listagemEstados"
          :noOptionsText="'Países não encontrados'"
          label="Naturalidade"
          idSelect="processo-form-socio-naturalidade"
          @valueSelect="$event => setNaturalidade($event)"
          placeholder="Selecione"
          :required="false"
          ref="campoSocioNaturalidade"
          :loading-data="loadingSelects"
          v-e2e="'naturalidade-socio-processo'"
        ></TrfSelect>
      </div>
      <div v-if="formData.nacionalidade == 105" class="column is-6">
        <TrfInput
          label="Município de nascimento"
          placeholder="Município de nascimento"
          margin="0"
          id="processo-form-socio-municipio-de-nascimento"
          v-model="formData.municipioDeNascimento"
          maxLength="100"
          ref="campoSocioMunicipioDeNascimento"
          v-e2e="'municipioNascimento-socio-processo'"
          :required="false"
        ></TrfInput>
      </div>
      <div class="column is-6">
        <TrfSelect
          :options="listagemEstadoCivil"
          :noOptionsText="'Estados cívis não encontrados'"
          label="Estado civil"
          idSelect="processo-form-socio-estado-civil"
          @valueSelect="$event => setEstadoCivil($event)"
          placeholder="Selecione"
          :required="false"
          ref="campoSocioEstadoCivil"
          :loading-data="loadingSelects"
          v-e2e="'estadoCivil-socio-processo'"
        ></TrfSelect>
      </div>
      <div class="column is-6">
        <TrfSelect
          :options="listagemRegimeCasamento"
          :noOptionsText="'Regimes de casamento não encontrados'"
          label="Regime de casamento"
          idSelect="processo-form-socio-regime-casamento"
          @valueSelect="$event => setRegimeDeCasamento($event)"
          placeholder="Selecione"
          :required="false"
          ref="campoSocioRegimeDeCasamento"
          :loading-data="loadingSelects"
          v-e2e="'regimeCasamento-socio-processo'"
        ></TrfSelect>
      </div>
    </div>
    <TrfCheckboxFields
      titulo="Qual o tipo de sócio?"
      :listaDeOpcoes="this.listagemTiposDeSocios"
      id="processo-form-socio-tipos"
      @update:valoresSelecionados="(novoValor) => setTiposDeSocios(novoValor)"
      ref="campoSocioTipo"
    />
    <br/>
    <TrfFormularioBaseEndereco
      @update:form-data="(formData) => setEndereco(formData)"
      id="processo-form-socio-endereco"
      ref="campoSocioEndereco"
    >
      <template #titulo>
        <p><strong>Qual o endereço do sócio?</strong></p>
      </template>
    </TrfFormularioBaseEndereco>
    <br/>
    <p><strong>Quais as informações de contato?</strong></p>
    <br/>
    <div class="columns is-multiline">
      <div class="column is-6">
        <TrfEmailInput
          label="E-mail"
          placeholder="E-mail de contato"
          margin="0"
          id="processo-form-socio-email-contato"
          v-model="formData.emailContato"
          maxLength="100"
          ref="campoSocioEmailContato"
          v-e2e="'email-socio-processo'"
          :required="false"
        ></TrfEmailInput>
      </div>
      <div class="column is-6">
        <TrfPhoneInput
          label="WhatsAPP"
          placeholder="WhatsAPP de contato"
          margin="0"
          id="processo-form-socio-whatsapp-contato"
          v-model="formData.whatsappContato"
          maxLength="15"
          ref="campoSocioWhatsappContato"
          v-e2e="'whatsapp-socio-processo'"
          :required="false"
        ></TrfPhoneInput>
      </div>
    </div>
  </div>
</template>
  <script>
  import { defineAsyncComponent } from 'vue';
  import { camposSocioStore } from '../../../../stateManagement/camposSocio';
  import { camposEnderecoStore } from '../../../../stateManagement/camposEndereco';
  import { opcoesRegimeCasamento } from '../../../../util/optionsEstaticos.utils.js';
  import Endereco from '../Models/endereco.model.js';
  import DadosSocio from '../Models/dados-socio.model';
  import { toastUtils } from '../../../../util/toast.utils.js';

  const TIPOS_DE_SOCIO = [
    'isAdministrador',
    'isResponsavelCnpj'
  ]
  
  export default {
    name: 'TrfSocioFormularioBase',
    expose: ['inicializarCampos', 'limparCampos', 'doCadastrar', 'doEditar'],
    components: {
      TrfInput: defineAsyncComponent(() => import('../../../../components/Input/index.vue')),
      TrfSelect: defineAsyncComponent(() => import('../../../../components/Select/index.vue')),
      TrfFormularioBaseEndereco: defineAsyncComponent(() => import('../../../../components/FormularioBaseEndereco/index.vue')),
      TrfCheckboxFields: defineAsyncComponent(() => import('../../../../components/CheckboxFields/index.vue')),
      TrfDateInput: defineAsyncComponent(() => import('../../../../components/Input/TrfDateInput.vue')),
      TrfEmailInput: defineAsyncComponent(() => import('../../../../components/Input/TrfEmailInput.vue')),
      TrfPhoneInput: defineAsyncComponent(() => import('../../../../components/Input/TrfPhoneInput.vue')),
      TrfDocumentoInput: defineAsyncComponent(() => import('../../../../components/Input/TrfDocumentoInput.vue'))
    },
    props: {
      preview: {
        type: Boolean,
        default: false,
        required: false
      },
      isVisualizacao: {
        type: Boolean,
        default: false,
        required: false
      },
    },
    data() {
      return {
        formData: {
          endereco: new Endereco()
        },
        listagemSexo: [],
        listagemCor: [],
        listagemEscolaridade: [],
        listagemEstadoCivil: [],
        listagemRegimeCasamento: [],
        listagemPaises: [],
        listagemEstados: [],
        listagemTiposDeSocios: [
          {
            id: "process-form-socio-tipos-administrador",
            label: "Administrador",
            isSelecionada: false,
            valor: 'isAdministrador'
          },
          {
            id: "process-form-socio-tipos-responsavel-cnpj",
            label: "Responsável CNPJ",
            isSelecionada: false,
            valor: 'isResponsavelCnpj'
          }
        ],
        loadingSelects: true,
        camposSocioStore: camposSocioStore
      };
    },
    computed: {
    },
    watch: {
      formData: {
        immediate: true,
        handler() {
          this.$emit('update:form-data', this.formData)
        },
        deep: true
      },
      'camposSocioStore.isLoadingTiposEscolaridade': {
        immediate: true,
        handler() {
          if(!camposSocioStore.isLoadingTiposEscolaridade) {            
            this.listagemEscolaridade = camposSocioStore.tiposEscolaridade;
          }
        },
      },
      'camposSocioStore.isLoadingTiposSexo': {
        immediate: true,
        handler() {
          if(!camposSocioStore.isLoadingTiposSexo) {            
            this.listagemSexo = camposSocioStore.tiposSexo;
          }
        },
      },
      'camposSocioStore.isLoadingTiposRaca': {
        immediate: true,
        handler() {
          if(!camposSocioStore.isLoadingTiposRaca) {            
            this.listagemCor = camposSocioStore.tiposRaca;
          }
        },
      },
      'camposSocioStore.isLoadingTiposEstadoCivil': {
        immediate: true,
        handler() {
          if(!camposSocioStore.isLoadingTiposEstadoCivil) {            
            this.listagemEstadoCivil = camposSocioStore.tiposEstadoCivil;
          }
        },
      },
    },
    methods: {
      async iniciarCamposSelect() {
        if (this.preview && !this.isVisualizacao) {
          this.loadingSelects = false;
          return;
        };
        
        this.loadingSelects = true;
        this.listagemRegimeCasamento = [...opcoesRegimeCasamento];
        await camposSocioStore.adquirirTodosOsCampos(); 
        await camposEnderecoStore.adquirirTodosOsCampos();
        this.listagemCor = camposSocioStore.tiposRaca;
        this.listagemEscolaridade = camposSocioStore.tiposEscolaridade;
        this.listagemEstadoCivil = camposSocioStore.tiposEstadoCivil;
        this.listagemPaises = camposEnderecoStore.paises;
        this.listagemEstados = camposEnderecoStore.estados;
        this.listagemSexo = camposSocioStore.tiposSexo;
        this.loadingSelects = false;
        await this.$nextTick();
      },
      inicializarCampos(details) {
        const dados = new DadosSocio();
        dados.updateDados(details);
        this.formData = dados;
        this.inicializarTipoDeSocio();
        this.inicializarSelects();
        this.$refs.campoSocioEndereco.inicializarCampos(details.endereco);
      },
      inicializarTipoDeSocio() {
        this.listagemTiposDeSocios.forEach((tipo) => {
          const tipoSocio = TIPOS_DE_SOCIO.find((item) => item == tipo.valor);
          tipo.isSelecionada = this.formData[tipoSocio]
        });
        this.$refs.campoSocioTipo.selecionarCheckboxes();
      },
      async inicializarSelects(){
        this.selecionarSexo();
        this.selecionarEscolaridade();
        this.selecionarEstadoCivil();
        this.selecionarRegimeDoCasamento();
        this.selecionarPaisDeNascimento();
        this.selecionarNacionalidade();
        await this.$nextTick();
        this.selecionarNaturalidade();
        this.selecionarCor();
      },
      selecionarSexo(){
        this.selecionarValorDoFormulario('campoSocioSexo', 'sexo');
      },
      selecionarEscolaridade(){
        this.selecionarValorDoFormulario('campoSocioEscolaridade', 'escolaridade');
      },
      selecionarEstadoCivil(){
        this.selecionarValorDoFormulario('campoSocioEstadoCivil', 'estadoCivil');
      },
      selecionarRegimeDoCasamento(){
        this.selecionarValorDoFormulario('campoSocioRegimeDeCasamento', 'regimeDoCasamento');
      },
      selecionarPaisDeNascimento(){
        this.selecionarValorDoFormulario('campoSocioPaisDeNascimento', 'paisDeNascimento');
      },
      selecionarNacionalidade(){
        this.selecionarValorDoFormulario('campoSocioNacionalidade', 'nacionalidade');
      },
      selecionarNaturalidade(){
        this.selecionarValorDoFormulario('campoSocioNaturalidade', 'naturalidade');
      },
      selecionarCor(){
        this.selecionarValorDoFormulario('campoSocioCor', 'cor');
      },
      selecionarValorDoFormulario(refNome, propriedadeFormulario) {
        if(!this.$refs[refNome]) return;
        if(!this.formData[propriedadeFormulario]) return;

        this.$refs[refNome].selecionar(this.formData[propriedadeFormulario]);
      },
      setEmpresa(formData) {
        this.formData.empresa = formData;
      },
      setSexo(valor) {
        this.formData.sexo = valor;
      },
      setCor(valor) {
        this.formData.cor = valor;
      },
      setEscolaridade(valor) {
        this.formData.escolaridade = valor;
      },
      setPaisDeNasciomento(valor) {
        this.formData.paisDeNascimento = valor;
      },
      setNacionalidade(valor) {
        this.formData.nacionalidade = valor;
      },
      setNaturalidade(valor) {
        this.formData.naturalidade = valor;
      },
      setEstadoCivil(valor) {
        this.formData.estadoCivil = valor;
      },
      setRegimeDeCasamento(valor) {
        this.formData.regimeDoCasamento = valor;
      },
      setTiposDeSocios(valores) {
        for (const opcao in TIPOS_DE_SOCIO) {
          const key = TIPOS_DE_SOCIO[opcao];
          this.formData[key] = valores.includes(key);
        }
      },
      setEndereco(formData) {
        this.formData.endereco.updateDados(formData);
      },
      doCadastrar() {
        const dados = new DadosSocio();
        dados.updateDados(this.formData);
        if(!this.validarCampos()) return;
        this.$emit('concluir-cadastro-socio', dados);
      },
      doEditar() {
        const dados = new DadosSocio();
        dados.updateDados(this.formData);
        if(!this.validarCampos()) return;
        this.$emit('concluir-edicao-socio', dados);
      },
      validarCampos() {
        const isValido = this.$refs.campoSocioCPF.verificarSeInputEValido()
          && this.$refs.campoSocioWhatsappContato.verificarSeInputEValido()
          && this.$refs.campoSocioEmailContato.verificarSeInputEValido()
          && this.$refs.campoSocioEndereco.$refs.campoEnderecoCep.verificarSeInputEValido();

        if(!isValido) {
          toastUtils.dangerToast('Campo(s) com dado(s) inválido(s)!');
        }
        
        return isValido;
      },
      async limparCampos() {
        this.$refs.campoSocioNome.limparInput();
        this.$refs.campoSocioNome.limparValidacao();
        this.$refs.campoSocioCPF.limparInput();
        this.$refs.campoSocioCPF.limparValidacao();
        this.$refs.campoSocioDataNascimento.limparInput();
        this.$refs.campoSocioDataNascimento.limparValidacao();
        this.$refs.campoSocioRg.limparInput();
        this.$refs.campoSocioRg.limparValidacao();
        this.$refs.campoSocioOrgaoEmissor.limparInput();
        this.$refs.campoSocioOrgaoEmissor.limparValidacao();
        this.$refs.campoSocioEmissaoIdentidade.limparInput();
        this.$refs.campoSocioEmissaoIdentidade.limparValidacao();
        this.$refs.campoSocioSexo.limparSelect();
        this.$refs.campoSocioSexo.limparValidacao();
        this.$refs.campoSocioCor.limparSelect();
        this.$refs.campoSocioCor.limparValidacao();
        this.$refs.campoSocioEscolaridade.limparSelect();
        this.$refs.campoSocioEscolaridade.limparValidacao();
        this.$refs.campoSocioPaisDeNascimento.limparSelect();
        this.$refs.campoSocioPaisDeNascimento.limparValidacao();
        this.$refs.campoSocioNacionalidade.limparSelect();
        this.$refs.campoSocioNacionalidade.limparValidacao();
        this.$refs.campoSocioEstadoCivil.limparSelect();
        this.$refs.campoSocioEstadoCivil.limparValidacao();
        this.$refs.campoSocioRegimeDeCasamento.limparSelect();
        this.$refs.campoSocioRegimeDeCasamento.limparValidacao();
        this.$refs.campoSocioTipo.limparCampos();
        this.formData.endereco = new Endereco();
        this.$refs.campoSocioEndereco.limparCampos();
        await this.$nextTick();
        this.$refs.campoSocioEmailContato.limparInput();
        this.$refs.campoSocioEmailContato.limparValidacao();
        this.$refs.campoSocioWhatsappContato.limparInput();
        this.$refs.campoSocioWhatsappContato.limparValidacao();
        if(this.$refs.campoSocioNaturalidade) {
          this.$refs.campoSocioNaturalidade.limparSelect();
          this.$refs.campoSocioNaturalidade.limparValidacao(); 
        }
        if(this.$refs.campoSocioMunicipioDeNascimento) {
          this.$refs.campoSocioMunicipioDeNascimento.limparInput();
          this.$refs.campoSocioMunicipioDeNascimento.limparValidacao();
        }
        this.formData = {
          endereco: new Endereco()
        }
      },
    },
    async created() {
      await this.iniciarCamposSelect();
    },
    mounted() {}
  };
  </script>
  <style lang="scss" scoped>
  .is-preview {
    pointer-events: none;
    cursor: default!important;
    * {
      pointer-events: none;
      cursor: default!important;
    }
  }
  .multiselect-econtador {
    margin: 0;
  }
  </style>
  